<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 257.49 56.36"
  >
    <defs>
      <style>
        .cls-1 {
          fill: none;
        }
        .cls-2 {
          clip-path: url(#clip-path);
        }
        .cls-3 {
          fill: #fff;
        }
        .cls-4 {
          fill: #5cb8d6;
        }
        .cls-5 {
          fill: #1d1d1b;
        }
      </style>
      <clipPath id="clip-path" transform="translate(0 0)">
        <rect class="cls-1" width="257.49" height="56.36" />
      </clipPath>
    </defs>
    <g id="Livello_2" data-name="Livello 2">
      <g id="Livello_1-2" data-name="Livello 1">
        <g class="cls-2">
          <rect class="cls-3" width="56.36" height="56.36" rx="5.12" />
          <path
            class="cls-4"
            d="M35.27,19.28a2.94,2.94,0,1,0-2.61-3.23,2.94,2.94,0,0,0,2.61,3.23"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M40.18,43.51a3.42,3.42,0,1,0-3-3.76,3.42,3.42,0,0,0,3,3.76"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M26.74,11.45a2.93,2.93,0,1,0-2.61-3.22,2.93,2.93,0,0,0,2.61,3.22"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M48.38,40.17a2,2,0,0,0,.41-3.89,2,2,0,1,0-.41,3.89"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M27.68,22.12A2,2,0,1,0,25.94,20a2,2,0,0,0,1.74,2.15"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M37.2,30.6a3.42,3.42,0,1,0-3-3.77,3.44,3.44,0,0,0,3,3.77"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M24.34,34.32a3.42,3.42,0,1,0-3.05-3.76,3.42,3.42,0,0,0,3.05,3.76"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M19,21.28a3.42,3.42,0,1,0-3.05-3.77A3.42,3.42,0,0,0,19,21.28"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M27.14,41.31a2,2,0,1,0-1.74-2.15,2,2,0,0,0,1.74,2.15"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M16.14,37.47a2,2,0,1,0,.41-3.89,2,2,0,1,0-.41,3.89"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M45.11,24.32a2,2,0,1,0-1.74-2.15,2,2,0,0,0,1.74,2.15"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M33.25,47.16a1.94,1.94,0,0,0,2.15-1.74,2,2,0,1,0-2.15,1.74"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M42.74,50.59a2,2,0,0,0,2.15-1.74A2,2,0,1,0,41,48.44a1.94,1.94,0,0,0,1.74,2.15"
            transform="translate(0 0)"
          />
          <path
            class="cls-4"
            d="M8.29,21.61a2.94,2.94,0,1,0-2.61-3.23,2.94,2.94,0,0,0,2.61,3.23"
            transform="translate(0 0)"
          />
        </g>
        <polygon
          class="cls-4"
          points="26.72 30.96 26.42 29.9 34.69 27.46 34.99 28.53 26.72 30.96"
        />
        <polygon
          class="cls-4"
          points="39.52 38.01 37.52 29.56 38.59 29.3 40.59 37.75 39.52 38.01"
        />
        <polygon
          class="cls-4"
          points="28.21 20.4 27.77 19.39 33.95 16.6 34.4 17.61 28.21 20.4"
        />
        <polygon
          class="cls-4"
          points="26.21 38.1 24.28 32.44 25.32 32.08 27.25 37.74 26.21 38.1"
        />
        <polygon
          class="cls-4"
          points="20.2 16.19 19.34 15.51 24.85 8.42 25.71 9.1 20.2 16.19"
        />
        <polygon
          class="cls-4"
          points="34.77 44.86 34.14 43.95 38.28 41.03 38.91 41.93 34.77 44.86"
        />
        <polygon
          class="cls-4"
          points="17.71 35.34 17.19 34.36 24.06 30.63 24.58 31.61 17.71 35.34"
        />
        <polygon
          class="cls-4"
          points="43.72 40.03 43.49 38.95 48.77 37.79 49 38.87 43.72 40.03"
        />
        <polygon
          class="cls-4"
          points="42.38 48.57 40.92 42.72 41.98 42.45 43.44 48.3 42.38 48.57"
        />
        <polygon
          class="cls-4"
          points="36.2 24.77 35.12 17.77 36.2 17.6 37.29 24.6 36.2 24.77"
        />
        <polygon
          class="cls-4"
          points="23.76 30.59 20.13 21.1 21.15 20.7 24.78 30.19 23.76 30.59"
        />
        <rect
          class="cls-4"
          x="10.53"
          y="17.91"
          width="8.4"
          height="1.1"
          transform="translate(-0.64 0.53) rotate(-2.02)"
        />
        <polygon
          class="cls-4"
          points="40.11 26.48 39.54 25.54 44.44 22.52 45.01 23.46 40.11 26.48"
        />
        <polygon
          class="cls-4"
          points="22.32 17.35 21.46 16.67 26.97 9.57 27.83 10.25 22.32 17.35"
        />
        <g class="cls-2">
          <path
            class="cls-3"
            d="M225.35,4.77h-8.17a2.33,2.33,0,0,0-1.66.65A2.18,2.18,0,0,0,214.85,7V31.7h5.64V22.57H225c3.14,0,5.58-.77,7.25-2.3a8.48,8.48,0,0,0,2.53-6.6,8.82,8.82,0,0,0-2.43-6.38c-1.61-1.67-4-2.52-7-2.52m3.72,8.86c0,2.88-1.4,4.28-4.29,4.28h-4.29V9.46h4.25a4.43,4.43,0,0,1,3.21,1.1,4.12,4.12,0,0,1,1.12,3.07"
            transform="translate(0 0)"
          />
          <path
            class="cls-3"
            d="M199.44,4.63c-1.95,0-3.22.74-3.76,2.2l-9.2,24.87h5.85l2.27-6.62h9.72l2.25,6.55,0,.07h5.84L203.24,6.87q-.83-2.24-3.8-2.24m3.26,15.72h-6.49l3.23-9.51Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-3"
            d="M255.07,7.29c-1.62-1.67-4-2.52-7-2.52h-8.16a2.29,2.29,0,0,0-1.66.65A2.13,2.13,0,0,0,237.6,7V31.7h5.64V22.57h4.48c3.13,0,5.57-.77,7.25-2.3a8.51,8.51,0,0,0,2.53-6.6,8.87,8.87,0,0,0-2.43-6.38m-3.26,6.34c0,2.88-1.4,4.28-4.28,4.28h-4.29V9.46h4.25a4.41,4.41,0,0,1,3.2,1.1,4.08,4.08,0,0,1,1.12,3.07"
            transform="translate(0 0)"
          />
        </g>
        <rect class="cls-5" x="171.87" width="1.32" height="36.4" />
        <g class="cls-2">
          <path
            class="cls-5"
            d="M140.26,26.8a12.25,12.25,0,0,1-2.88-8.56q0-5.44,2.88-8.62a9.63,9.63,0,0,1,7.52-3.19,9.49,9.49,0,0,1,7.43,3.19q2.86,3.18,2.86,8.62c0,3.59-.95,6.45-2.86,8.56A9.54,9.54,0,0,1,147.78,30a9.69,9.69,0,0,1-7.52-3.17M157,28.29a14.37,14.37,0,0,0,3.48-10q0-6.27-3.48-10.11a12.92,12.92,0,0,0-18.4,0A14.37,14.37,0,0,0,135,18.24a14.25,14.25,0,0,0,3.53,10.07,12,12,0,0,0,9.23,3.81A11.83,11.83,0,0,0,157,28.29M114.65,4.77V6.88h8.68V31.7h2.29V6.88h8.69V4.77Zm-2.86,0h-15a1.56,1.56,0,0,0-1,.32,1.18,1.18,0,0,0-.4,1V31.7h16.08V29.59H97.73V19h12.84V16.88H97.73v-10h14.06ZM78.63,18.54,91.43,4.77H88.65L76.23,18.12V4.77H74V31.7h2.28V19.33l13,12.37h3.12Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-5"
            d="M233.76,53.21a1.87,1.87,0,0,0,.85-1.64,1.56,1.56,0,0,0-.64-1.38,6.45,6.45,0,0,0-1.93-.84h0l-.06,0-.58-.18-.49-.22a1,1,0,0,1-.39-.34.89.89,0,0,1,.32-1.24,2.06,2.06,0,0,1,1.13-.28,3.39,3.39,0,0,1,1.93.63l.57-.81a4.05,4.05,0,0,0-2.5-.79,3.36,3.36,0,0,0-2,.54,1.8,1.8,0,0,0-.77,1.56,1.59,1.59,0,0,0,.6,1.34,5.19,5.19,0,0,0,1.7.8l.37.11.4.12.34.13a1.24,1.24,0,0,1,.33.17c.08,0,.16.12.25.19a.57.57,0,0,1,.18.28.88.88,0,0,1,0,.33.91.91,0,0,1-.51.84,2.53,2.53,0,0,1-1.22.29,3.38,3.38,0,0,1-2.33-.94l-.59.78a3.05,3.05,0,0,0,1.28.86,4.47,4.47,0,0,0,1.62.3,3.69,3.69,0,0,0,2.09-.58m-7.6-.55a1.21,1.21,0,0,1-.85-.33,1.28,1.28,0,0,1-.35-1V47.23h2.64v-.95H225V44h-1.21v2.28h-1.3v.95h1.3v4a2.89,2.89,0,0,0,.55,1.85,2.06,2.06,0,0,0,1.69.68,3.34,3.34,0,0,0,2-.65l-.49-.93a2.46,2.46,0,0,1-1.33.45m-5-9.53H220V53.62h1.2Zm-4.47,8.29A4.69,4.69,0,0,1,214,52.71a1.17,1.17,0,0,1-.93-.34,1.62,1.62,0,0,1-.3-1.08v-5h-1.21v5.26a2.26,2.26,0,0,0,.6,1.69,2.33,2.33,0,0,0,1.7.59,4.37,4.37,0,0,0,2.89-1.4v1.22h1.2V46.28H216.7Zm-7.5,1.79a1.87,1.87,0,0,0,.85-1.64,1.56,1.56,0,0,0-.64-1.38,6.45,6.45,0,0,0-1.93-.84h0l-.06,0-.58-.18-.49-.22a1,1,0,0,1-.39-.34.8.8,0,0,1-.13-.46.88.88,0,0,1,.45-.78,2,2,0,0,1,1.13-.28,3.33,3.33,0,0,1,1.92.63l.58-.81a4.05,4.05,0,0,0-2.5-.79,3.36,3.36,0,0,0-2,.54,1.8,1.8,0,0,0-.77,1.56,1.59,1.59,0,0,0,.6,1.34,5.19,5.19,0,0,0,1.7.8l.37.11.4.12.34.13a1.24,1.24,0,0,1,.33.17c.08,0,.16.12.25.19a.57.57,0,0,1,.18.28.88.88,0,0,1,.05.33.91.91,0,0,1-.51.84,2.53,2.53,0,0,1-1.22.29,3.38,3.38,0,0,1-2.33-.94l-.59.78a3.05,3.05,0,0,0,1.28.86,4.47,4.47,0,0,0,1.62.3,3.69,3.69,0,0,0,2.09-.58m-7.66-5.73a1.33,1.33,0,0,1,.5,1,1,1,0,0,1-.27.77,1,1,0,0,1-.7.26h-3.35a2.81,2.81,0,0,1,.79-1.82,2.31,2.31,0,0,1,1.7-.68,1.94,1.94,0,0,1,1.33.44m-3.1,4.63a2.73,2.73,0,0,1-.71-1.64h3.49a2,2,0,0,0,1.44-.5,1.8,1.8,0,0,0,.52-1.36,2.2,2.2,0,0,0-.87-1.86,3.24,3.24,0,0,0-2-.66,3.53,3.53,0,0,0-2.81,1.14,4.2,4.2,0,0,0-1,2.84,3.65,3.65,0,0,0,1,2.74,3.43,3.43,0,0,0,2.48,1A4.47,4.47,0,0,0,203,52.63l-.65-.86a3.36,3.36,0,0,1-2.35.94,2.12,2.12,0,0,1-1.59-.6m-4.69-5.72a2.89,2.89,0,0,0-1.07.86v-1h-1.19v7.34h1.22V48.31A3.11,3.11,0,0,1,195,47.2a4.5,4.5,0,0,1,.79.11l.19-1.05a2.44,2.44,0,0,0-.9-.17,3,3,0,0,0-1.31.3m-8.16,6.9A3.61,3.61,0,0,0,186.78,52l-.92-.63a2.67,2.67,0,0,1-2.25,1.33,2.16,2.16,0,0,1-1.67-.7,3.6,3.6,0,0,1,0-4.17,2.24,2.24,0,0,1,1.71-.72,2.16,2.16,0,0,1,2.05,1.2l1-.6a3.14,3.14,0,0,0-3-1.66A3.4,3.4,0,0,0,181,47.15a4.51,4.51,0,0,0,0,5.59,3.33,3.33,0,0,0,2.59,1.08,3.54,3.54,0,0,0,2-.53m-7.17-7h-1.23v7.34h1.23Zm.21-1.91a.77.77,0,0,0-.82-.82.77.77,0,0,0-.59.22.78.78,0,0,0-.23.6.81.81,0,0,0,.23.6.77.77,0,0,0,.59.22.78.78,0,0,0,.59-.22.81.81,0,0,0,.23-.6m-2.94.15.58-.87a3,3,0,0,0-2-.69,2.85,2.85,0,0,0-.8.11,4,4,0,0,0-.89.37,2,2,0,0,0-.78.86,3.13,3.13,0,0,0-.3,1.42v.56h-1.26v.95h1.26v6.39h1.21V47.23h2.81v-.95h-2.81v-.46a1.7,1.7,0,0,1,.48-1.36,1.75,1.75,0,0,1,1.17-.4,2.1,2.1,0,0,1,1.32.46M169,46.28h-1.24v7.34H169Zm.2-1.91a.78.78,0,0,0-.22-.6.8.8,0,0,0-.59-.22.81.81,0,0,0-.6.22.82.82,0,0,0-.22.6.85.85,0,0,0,.22.6.81.81,0,0,0,.6.22.8.8,0,0,0,.59-.22.81.81,0,0,0,.22-.6m-4,8.92A3.49,3.49,0,0,0,166.36,52l-.92-.63a2.64,2.64,0,0,1-2.24,1.33,2.16,2.16,0,0,1-1.67-.7,3,3,0,0,1-.66-2.09,2.92,2.92,0,0,1,.67-2.08,2.23,2.23,0,0,1,1.71-.72,2.14,2.14,0,0,1,2,1.2l1-.6a3.15,3.15,0,0,0-3-1.66,3.4,3.4,0,0,0-2.64,1.06,4.51,4.51,0,0,0,0,5.59,3.32,3.32,0,0,0,2.59,1.08,3.57,3.57,0,0,0,2-.53m-8.37-5.81a1.33,1.33,0,0,1,.5,1,1,1,0,0,1-.27.77,1,1,0,0,1-.7.26H153a2.81,2.81,0,0,1,.79-1.82,2.31,2.31,0,0,1,1.7-.68,1.94,1.94,0,0,1,1.33.44m-3.1,4.63a2.66,2.66,0,0,1-.7-1.64h3.48a2,2,0,0,0,1.44-.5,1.8,1.8,0,0,0,.52-1.36,2.2,2.2,0,0,0-.87-1.86,3.24,3.24,0,0,0-2-.66,3.54,3.54,0,0,0-2.81,1.14,4.2,4.2,0,0,0-1,2.84,3.65,3.65,0,0,0,1,2.74,3.44,3.44,0,0,0,2.49,1,4.47,4.47,0,0,0,3.05-1.16l-.65-.86a3.34,3.34,0,0,1-2.34.94,2.13,2.13,0,0,1-1.6-.6m-8.8,0V48.23a3,3,0,0,1,2.26-1.07,1.86,1.86,0,0,1,1.53.69,3.2,3.2,0,0,1,.55,2,3.38,3.38,0,0,1-.61,2.14,2.06,2.06,0,0,1-1.68.75,3.69,3.69,0,0,1-2.05-.66m0-5v-.81H143.7V56.36h1.21V53.17a3.84,3.84,0,0,0,2.14.65,3.11,3.11,0,0,0,2.49-1.11,4.34,4.34,0,0,0,.94-2.88,4.18,4.18,0,0,0-.85-2.71,2.83,2.83,0,0,0-2.3-1,3.38,3.38,0,0,0-2.42,1m-3.59,6.12a1.87,1.87,0,0,0,.85-1.64,1.56,1.56,0,0,0-.64-1.38,6.49,6.49,0,0,0-1.92-.84h-.05l-.06,0-.58-.18-.49-.22a1.1,1.1,0,0,1-.39-.34.89.89,0,0,1,.32-1.24,2.06,2.06,0,0,1,1.13-.28,3.39,3.39,0,0,1,1.93.63l.58-.81a4.1,4.1,0,0,0-2.51-.79,3.35,3.35,0,0,0-2,.54,1.78,1.78,0,0,0-.78,1.56,1.59,1.59,0,0,0,.6,1.34,5.19,5.19,0,0,0,1.7.8l.37.11.4.12.34.13a1.24,1.24,0,0,1,.33.17c.08,0,.16.12.25.19a.57.57,0,0,1,.18.28.88.88,0,0,1,.06.33.92.92,0,0,1-.52.84,2.53,2.53,0,0,1-1.22.29,3.38,3.38,0,0,1-2.33-.94l-.59.78a3.05,3.05,0,0,0,1.28.86,4.47,4.47,0,0,0,1.62.3,3.67,3.67,0,0,0,2.09-.58m-10.83-5.73a1.32,1.32,0,0,1,.49,1,1,1,0,0,1-.26.77,1,1,0,0,1-.7.26h-3.35a2.85,2.85,0,0,1,.78-1.82,2.35,2.35,0,0,1,1.71-.68,2,2,0,0,1,1.33.44m-3.1,4.63a2.73,2.73,0,0,1-.71-1.64h3.49a2,2,0,0,0,1.44-.5,1.84,1.84,0,0,0,.52-1.36,2.2,2.2,0,0,0-.87-1.86,3.25,3.25,0,0,0-2-.66,3.52,3.52,0,0,0-2.8,1.14,4.21,4.21,0,0,0-1,2.84,3.65,3.65,0,0,0,1,2.74,3.4,3.4,0,0,0,2.48,1A4.47,4.47,0,0,0,132,52.63l-.65-.86a3.38,3.38,0,0,1-2.35.94,2.12,2.12,0,0,1-1.59-.6m-4.69-5.72a2.89,2.89,0,0,0-1.07.86v-1h-1.19v7.34h1.22V48.31a3.11,3.11,0,0,1,2.27-1.11,4.3,4.3,0,0,1,.78.11l.2-1.05a2.46,2.46,0,0,0-.91-.17,3,3,0,0,0-1.3.3M112.92,50a3.21,3.21,0,0,1,.59-2.07,2.44,2.44,0,0,1,3.45,0A4,4,0,0,1,117,52a2.46,2.46,0,0,1-3.46,0,3.2,3.2,0,0,1-.58-2.08m5.86,0a4,4,0,0,0-1-2.8,3.65,3.65,0,0,0-5.14,0,4.56,4.56,0,0,0,0,5.61,3.37,3.37,0,0,0,2.59,1.06,3.33,3.33,0,0,0,2.58-1.06,4,4,0,0,0,1-2.81M104.84,47.4a2,2,0,0,0-2.14-1.31,4.27,4.27,0,0,0-2.8,1.38V46.28H98.68v7.34h1.25V48.45a6.61,6.61,0,0,1,1.41-1,2.75,2.75,0,0,1,1.21-.28,1.12,1.12,0,0,1,.92.34,1.81,1.81,0,0,1,.28,1.13v5H105V48.38a5.39,5.39,0,0,1,1.32-.92,3.18,3.18,0,0,1,1.32-.27,1.13,1.13,0,0,1,.92.34,1.81,1.81,0,0,1,.28,1.13v5h1.23V48.38a2,2,0,0,0-2.28-2.29,4.27,4.27,0,0,0-2.94,1.31m-12.76-1a2.82,2.82,0,0,0-1.07.86v-1H89.82v7.34H91V48.31a3.11,3.11,0,0,1,2.27-1.11,4.3,4.3,0,0,1,.78.11l.2-1.05a2.46,2.46,0,0,0-.91-.17,3,3,0,0,0-1.3.3M82.3,50a3.15,3.15,0,0,1,.59-2.07,2.44,2.44,0,0,1,3.45,0,4,4,0,0,1,0,4.16,2.46,2.46,0,0,1-3.46,0A3.2,3.2,0,0,1,82.3,50m5.86,0a4,4,0,0,0-1-2.8,3.65,3.65,0,0,0-5.14,0,4,4,0,0,0-1,2.8,3.93,3.93,0,0,0,1,2.81,3.37,3.37,0,0,0,2.59,1.06,3.33,3.33,0,0,0,2.58-1.06,4,4,0,0,0,1-2.81m-7.89-6.82H74.61a.76.76,0,0,0-.46.16.53.53,0,0,0-.2.46v9.87h1.29V48.81h4.35V47.65H75.24V44.3h5Z"
            transform="translate(0 0)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
}
</script>
